import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { orgRoutes, settingsRoutes } from '@/routes/org-routes.const'

import type { UseConnectorDetailReturn } from './use-connector-detail.hook'

interface UseConnectorDetailNavigationReturn {
  navigateBack: () => void
}

export const useConnectorDetailNavigation = (
  detail: UseConnectorDetailReturn
): UseConnectorDetailNavigationReturn => {
  const { orgSlug } = useParams<{ orgSlug: string }>()
  const navigate = useNavigate()
  const connectorsPath = `/${orgSlug}/${orgRoutes.settings}/${settingsRoutes.connectors}`

  useEffect(() => {
    if (!detail.isLoading && !detail.provider) {
      navigate(connectorsPath, { replace: true })
    }
  }, [detail.isLoading, detail.provider, navigate, connectorsPath])

  const navigateBack = (): void => {
    navigate(connectorsPath)
  }

  return { navigateBack }
}
